import type { PlaywireAd } from '@creator/sdk/modules/config/config.model';
import RenderOnViewportEntry from '@creator/ui/components/RenderOnViewportEntry/RenderOnViewportEntry';
import { cn } from '@creator/ui/utils/ui';
import { shouldDisplayAds } from '@src/model/config/helpers';
import useAd from '@src/store/domain/useAd';
import { memo } from 'react';
import PlaywireAdSlot from '../PlaywireAd/PlaywireAdSlot';

interface AdvertisingSlotProps {
    location: string;
    playWireLocation?: string; // to override default location in special cases
    tokenName: string;
    className?: string;
    divIdSufix?: string; // for rerender in same page navigation (eg from post page to another post)
}

const AdvertisingSlot: React.FC<AdvertisingSlotProps> = (props: AdvertisingSlotProps) => {
    const { divIdSufix = '0', location, playWireLocation = '', className = '', tokenName } = props;

    const { ad, provider, sizeStyle } = useAd(location, tokenName, playWireLocation);
    if (!ad || !shouldDisplayAds(tokenName)) return <div className="" />;

    function getBaseClassName() {
        const base = 'transition cursor-pointer flex justify-center items-center w-max h-max';
        return `${base} mx-auto`;
    }

    function renderPlaywireAd() {
        const { divId, type } = ad as PlaywireAd;
        return <PlaywireAdSlot divId={divId} divIdSufix={divIdSufix} type={type} />;
    }

    function renderAdSlot() {
        if (provider === 'playwire') return renderPlaywireAd();
    }

    return (
        <RenderOnViewportEntry className={cn(getBaseClassName(), className)} style={sizeStyle}>
            {renderAdSlot()}
        </RenderOnViewportEntry>
    );
};

export default memo(AdvertisingSlot);
